import { BaseDashboardViewState, INITIAL_DASHBOARD_VIEW_STATE } from '../documents.state';

export interface InboxDocumentsState {
  dashboardView: BaseDashboardViewState;
}

export const INITIAL_INBOX_DOCUMENTS_STATE: InboxDocumentsState = {
  dashboardView: {
    ...INITIAL_DASHBOARD_VIEW_STATE,
    searchParams: { ...INITIAL_DASHBOARD_VIEW_STATE.searchParams, defaultDateRange: true },
  },
};
